module.exports = __webpack_public_path__ + "media/components/country-flag/static/ky-7b84db80995b2a64b65e1bcf0430da6b.svg";